import React from "react";
import { User } from "oidc-client-ts";
import Button from "@fv-components/button";
import { useAuth } from "./authContext";
import { getEnvironment, userManager } from "./oidcClient";
import EphemeralId from "../EphemeralId";
import { getIsOutlook } from "../util-helpers/office";
import { version } from "../version.json";
import { navigateToEnvironmentSelector } from "../util-helpers/environmentUtils";
import { createDialog } from "../util-helpers/dialogUtils";

const css = require("./auth.module.scss");

export default function SigninAction() {
  const { contextSignin } = useAuth();

  const outlookDesc = "The Filevine Add-in provides a window into your Filevine projects from inside Outlook. Quickly send emails to your Filevine project, add activities, and reference project data, all without leaving Outlook.";
  const officeDesc = "The Filevine Add-in provides a window into your Filevine projects from inside Office. Quickly save documents, spreadsheets, or presentations to your Filevine project, add activities, and reference project data, all without leaving Office.";
  const desc = getIsOutlook() ? outlookDesc : officeDesc;


  const handleSignin = () => {
    createDialog('signin.html')
    .then((msg) => {
      if (msg.oidcUserStorageString) {
        const user = User.fromStorageString(msg.oidcUserStorageString);
        userManager.storeUser(user);
        contextSignin(user, true);
      }
    }).catch((error) => {
      const err = String(error || '');
      if (err.includes('Dialog closed by user')) return;
      console.error('SigninAction error:', error);
    });
  };

  const getLocation = () => {
    const env = getEnvironment();
    switch (env) {
      case "US":
        return "United States";
      case "CA":
        return "Canada";
      case "CJIS":
        return "FilevineGov";
      case "NONPROD":
        return "Non-Prod";
      case "LOCAL":
        return "Local";
      default:
        return "Unknown";
    }
  };

  const handleChangeLocation = () => {
    navigateToEnvironmentSelector();
  };

  return (
    <div className={css.loginContainer}>
      <EphemeralId />
      <img className={css.logo} src="assets/fv-logo.svg" alt="Filevine" />
      <Button
        raised
        type="submit"
        className={css.loginButton}
        data-test="sign-in"
        onClick={handleSignin}
      >
        Sign In
      </Button>
      <small>
        <p>{desc}</p>
        <br />
        <br />
        <div>Don’t have a Filevine account?</div>
        <a
          href="https://www.filevine.com/demo-request?utm_source=outlook"
          target="_blank"
          rel="noopener noreferrer"
        >
          Schedule your demo today.
        </a>
      </small>
      <div className={css.version}>{`v${version}`}</div>

      <div className={css.location}>
        Location:
        {' '}
        {getLocation()}
      </div>

      <Button
        onClick={handleChangeLocation}
        className={css.refreshButton}
        title="Reselect Environment"
      >
        <span>Change Location</span>
      </Button>
    </div>
  );
}
